<div class="vflex-300">
  <h2>Loader</h2>
  <div class="surface-muted border-radius-200 pad-200">
    <code>
      import &#123; LoaderComponent &#125; from '&#64;spaces-ui/meadow/components/loader';
    </code>
  </div>

  <h3>Plain loader</h3>
  <ng-template #plainLoader data-sample="plainLoader">
    <div class="vflex-200">
      <mdw-loader></mdw-loader>
    </div>
  </ng-template>
  <app-sample [sampleContent]="plainLoader" sampleName="plainLoader"></app-sample>

  <hr />

  <h3>Loader with text (vertical)</h3>
  <ng-template #verticalLoadingText data-sample="verticalLoadingText">
    <div class="vflex-200">
      <div class="inline-flex">
        <mdw-loader class="vflex-100 flex-align-items-center">Loading Text</mdw-loader>
      </div>
    </div>
  </ng-template>
  <app-sample [sampleContent]="verticalLoadingText" sampleName="verticalLoadingText"></app-sample>

  <hr />

  <h3>Loader with text (horizontal)</h3>
  <ng-template #horizontalLoadingText data-sample="horizontalLoadingText">
    <div class="vflex-200">
      <div>
        <mdw-loader class="hflex-075">Loading Text</mdw-loader>
      </div>
    </div>
  </ng-template>
  <app-sample
    [sampleContent]="horizontalLoadingText"
    sampleName="horizontalLoadingText"
  ></app-sample>

  <hr />

  <h3>Loader with forced theme (Danger Button)</h3>
  <ng-template #dangerLoader data-sample="dangerLoader">
    <div class="vflex-200">
      <div>
        <button class="mdw-button mdw-danger large-button">
          <mdw-loader class="hflex-075">Loading Text</mdw-loader>
        </button>
      </div>
    </div>
  </ng-template>
  <app-sample [sampleContent]="dangerLoader" sampleName="dangerLoader"></app-sample>

  <h3>Loader with forced theme (Primary Button)</h3>
  <ng-template #successLoader data-sample="successLoader">
    <div class="vflex-200">
      <div>
        <button class="mdw-button mdw-primary large-button">
          <mdw-loader class="hflex-075">Loading Text</mdw-loader>
        </button>
      </div>
    </div>
  </ng-template>
  <app-sample [sampleContent]="successLoader" sampleName="successLoader"></app-sample>
</div>
